import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

//import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import auth from "@/auth/store";
import filiation from "@/filiation/store";
import addTransfersDepartures from "@/addTransfersDepartures/store";
import penitentiary from "@/penitentiary/store";
import user from "@/user/store";
import visits from "@/visits/store";
import mod_education from "@/mod_education/store";
import mod_psychologic from "@/mod_psychologic/store";
import mod_social from "@/mod_social/store"
config.rawError = true;

const store = createStore({
  modules: {
    //  AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    auth,
    filiation,
    addTransfersDepartures,
    penitentiary,
    user,
    visits,
    mod_education,
    mod_psychologic,
    mod_social
  },
});

export default store;
